import React from "react";
import {
  FlatActionList,
  FlatActionListItem,
  Page,
} from "@towersystems/roam-common-native";
import { Feather } from "@expo/vector-icons";
import { StackScreenProps } from "@react-navigation/stack";
import {
  useGlobalSettingsProvider,
  useMutationUpdateGlobalSettings,
} from "../../../../utilities/global-settings/hooks";

const AUSTRALIAN_TIMEZONES = [
  { label: "Sydney / Melbourne / Hobart (AEDT/AEST)", value: "Australia/Sydney" },
  { label: "Brisbane (AEST, no daylight saving)", value: "Australia/Brisbane" },
  { label: "Adelaide (ACDT/ACST)", value: "Australia/Adelaide" },
  { label: "Darwin (ACST, no daylight saving)", value: "Australia/Darwin" },
  { label: "Perth (AWST)", value: "Australia/Perth" },
  { label: "Lord Howe Island", value: "Australia/Lord_Howe" },
];

const NEW_ZEALAND_TIMEZONES = [
  { label: "Auckland / Wellington (NZDT/NZST)", value: "Pacific/Auckland" },
  { label: "Chatham Islands (CHADT/CHAST)", value: "Pacific/Chatham" },
];

export type SelectTimezoneScreenProps = StackScreenProps<
  any,
  "SelectTimezoneScreen"
>;

export const SelectTimezoneScreen = ({
  navigation,
}: SelectTimezoneScreenProps) => {
  const { timezone } = useGlobalSettingsProvider();
  const { updateGlobalSettings } = useMutationUpdateGlobalSettings();

  const handleSelect = async (tz: string) => {
    try {
      await updateGlobalSettings({ timezone: tz });
      navigation.goBack();
    } catch (error) {
      console.error("Failed to update timezone", error);
    }
  };

  const items: FlatActionListItem[] = React.useMemo(
    () =>
      [...AUSTRALIAN_TIMEZONES, ...NEW_ZEALAND_TIMEZONES].map((option) => ({
        id: option.value,
        key: option.value,
        title: option.label,
        icon: <Feather name="check" size={24} color="black" />,
        onPress: () => handleSelect(option.value),
        selected: timezone === option.value,
      })),
    [timezone],
  );

  return (
    <Page title="Select Timezone">
      <FlatActionList items={items} />
    </Page>
  );
};
